module.exports = __webpack_public_path__ + "static/media/Multi Compressor HD VR.9195cfa.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/hd-racks/Multi Compressor HD VR.mp3
// module id = BPMf
// module chunks = 12